"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 26 26",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "var(--sds--ursa-icons--background-color, transparent)",
  d: "M3.7 17.252a2 2 0 0 1 1.58-1.956l2.45-.527a17 17 0 0 1 7.15 0l2.45.527a2 2 0 0 1 1.58 1.956v.929a4 4 0 0 1-4 4H7.7a4 4 0 0 1-4-4z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M18.5 4.4h-7.842a3.1 3.1 0 0 0-3.1 3.1h-1.4a4.5 4.5 0 0 1 4.5-4.5H18.5A4.5 4.5 0 0 1 23 7.5v7.842a4.5 4.5 0 0 1-4.5 4.5v-1.4a3.1 3.1 0 0 0 3.1-3.1V7.5a3.1 3.1 0 0 0-3.1-3.1"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M15.384 7.558H7.458A3.06 3.06 0 0 0 4.4 10.616v8.421A2.563 2.563 0 0 0 6.963 21.6h8.38a3.1 3.1 0 0 0 3.1-3.1v-7.884a3.06 3.06 0 0 0-3.06-3.058m0-1.4H7.458A4.46 4.46 0 0 0 3 10.616v8.421A3.963 3.963 0 0 0 6.963 23h8.38a4.5 4.5 0 0 0 4.5-4.5v-7.884a4.46 4.46 0 0 0-4.46-4.458",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M7.011 15.717c-1.35.292-2.453.719-3.18 1.243l-.82-1.135c.949-.684 2.264-1.164 3.704-1.477 1.451-.314 3.083-.469 4.706-.47 1.623 0 3.255.156 4.707.47 1.44.312 2.755.793 3.703 1.477l-.82 1.135c-.726-.524-1.83-.95-3.18-1.244-1.339-.29-2.87-.437-4.41-.437s-3.07.148-4.41.438",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M8.484 11a.9.9 0 1 1-1.8 0 .9.9 0 0 1 1.8 0"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=ContentLibraryIcon26.js.map